import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs/operators';
import { ToastService } from '../../../_core/services/toast.service';
import { Tournament } from '../../../_shared/models/tournament.model';
import { TournamentDetailsService } from '../tournament-details.service';

@Component({
    selector: 'app-tournament-notification',
    templateUrl: './tournament-notification.component.html',
    styleUrls: ['./tournament-notification.component.scss'],
    standalone: true,
    imports: [
        IonicModule,
        FormsModule,
        TranslateModule
    ]
})
export class TournamentNotificationComponent implements OnInit {
    private destroyRef = inject(DestroyRef);
    private tournamentDetailsService = inject(TournamentDetailsService);
    private toastService = inject(ToastService);
    private translateService = inject(TranslateService);
    private modalController = inject(ModalController);

    @Input() tournament: Tournament;

    message: string = '';
    enabled: boolean = false;
    textUpperCase: boolean = false;
    isSaving: boolean = false;
    color: string = '';

    ngOnInit() {
        if (this.tournament) {
            this.message = this.tournament.notification?.message || '';
            this.enabled = this.tournament.notification?.enabled || false;
            this.textUpperCase = this.tournament.notification?.textUpperCase || false;
            this.color = this.tournament.notification?.color || '';
        }
    }

    saveNotification() {
        if (!this.tournament?._id) return;
        
        this.isSaving = true;
        this.tournamentDetailsService
            .updateNotification(this.tournament._id, this.message, this.enabled, this.textUpperCase, this.color)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                finalize(() => this.isSaving = false)
            )
            .subscribe({
                next: () => {
                    this.tournament.notification = { 
                        message: this.message, 
                        enabled: this.enabled,
                        textUpperCase: this.textUpperCase,
                        color: this.color
                    };
                    this.toastService.presentToast(this.translateService.instant('Notification updated successfully'));
                    this.modalController.dismiss({
                        updated: true,
                        notification: { 
                            message: this.message, 
                            enabled: this.enabled,
                            textUpperCase: this.textUpperCase,
                            color: this.color
                        }
                    });
                },
                error: (err) => {
                    const errorMessage = err.error?.message || this.translateService.instant('Failed to update notification');
                    this.toastService.presentDangerToast(errorMessage);
                }
            });
    }

    dismiss() {
        this.modalController.dismiss();
    }
}
